import { useTranslate } from 'react-admin'
import useTranslateParse from 'util/useTranslateParse'

const Subtitle = () => {
  const translate = useTranslate()
  const translateParse = useTranslateParse()
  return (
    <div>
      <span>{translate('Add and edit roles on this page.')}</span>{' '}
      <span>
        {translateParse('For a detailed overview of role permissions see <a>here<a>', {
          a: (label) => (
            <a
              href={
                'https://support.opensolar.com/hc/en-us/articles/12299933220111-How-to-create-custom-roles-and-add-team-members'
              }
              target="_blank"
              rel="noreferrer"
            >
              {label}
            </a>
          ),
        })}
        .
      </span>
    </div>
  )
}

export const CustomRoles_user = {
  list: { lazy: () => import('./CustomRoleList') },
  edit: { lazy: () => import('./CustomRoles'), component: 'CustomRoleEdit' },
  create: { lazy: () => import('./CustomRoles'), component: 'CustomRoleCreate' },
  options: {
    list: {
      title: 'Custom Roles',
      subtitle: <Subtitle />,
      breadCrumb: 'Custom Roles',
    },
    create: {
      title: 'Create Custom Role',
      subtitle: 'Create custom roles with new permissions.',
      breadCrumb: 'Create Custom Role',
    },
    edit: {
      title: 'Edit Custom Role',
      subtitle: null,
      breadCrumb: 'Edit Custom Role',
    },
  },
}

export const CustomRoles_orgs = {
  ...CustomRoles_user,
  list: { lazy: () => import('./CustomRoleList'), component: 'CustomRoleListOrgs' },
  edit: { lazy: () => import('./CustomRoles'), component: 'CustomRoleEdit' },
  create: { lazy: () => import('./CustomRoles'), component: 'CustomRoleCreateOrgs' },
  options: {
    list: {
      title: 'Sharing Permissions',
      subtitle: 'Permission sets for limiting access to shared projects.',
      breadCrumb: 'Sharing Permissions',
    },
    create: {
      title: 'Create Sharing Permissions',
      subtitle: 'Create permissions for shared projects.',
      breadCrumb: 'Create Sharing Permissions',
    },
    edit: {
      title: 'Edit Sharing Permissions',
      subtitle: null,
      breadCrumb: 'Edit Sharing Permissions',
    },
  },
}
